/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailingTaskGrid/Types" />

export interface IPipelineRunData {
    run: {
        id: number;
        buildNumber: string;
        sourceBranch: string;
        repository: {
            id: string;
            name: string;
            type: string;
        };
        sourceVersion: string;
        triggerInfo: { [key: string]: string };
    };
    sourceVersionMessage: string;
}

export interface IPipelineRunsData {
    continuationToken: string;
    runs: IPipelineRunData[];
}

export interface ITreeData {
    description: string;
    isTask: boolean;
    stageName?: string;
    pipelineRunId?: number;
    sourceBranch?: string;
    triggerInfo?: { [key: string]: string };
    commitId?: string;
    commitUrl?: string;
    repositoryUrl?: string;
    repositoryType?: string;
    pullRequestUrl?: string;
    showMore?: boolean;
    noRunsData?: boolean;
    pipelineRunIdList?: number[];
}

export interface ITaskData {
    stageName: string;
    stageDisplayName: string;
    taskName: string;
}